import { __assign } from "tslib";
import * as React from 'react';
import { TravellerFieldEnum } from '@websky/core/src/__generated__/globalTypes';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { useField } from 'react-final-form';
import css from './Traveller.css';
import { useTranslation } from 'react-i18next';
var Traveller = function (_a) {
    var traveller = _a.traveller, segmentIndex = _a.segmentIndex, travellerIndex = _a.travellerIndex, subsidyInfo = _a.subsidyInfo;
    var firstName = traveller.values.find(function (item) { return item.type === TravellerFieldEnum.FirstName; }).value, lastName = traveller.values.find(function (item) { return item.type === TravellerFieldEnum.LastName; }).value, birthdate = traveller.values.find(function (item) { return item.type === TravellerFieldEnum.BirthDate; }).value;
    var field = useField("segments[".concat(segmentIndex, "].travellers[").concat(travellerIndex, "].check"), {
        type: 'checkbox'
    });
    var t = useTranslation('Subsidy').t;
    return (React.createElement(FormControlLabel, { disabled: !subsidyInfo || !!subsidyInfo.rejectMessage, control: React.createElement(Checkbox, { color: "primary", inputProps: __assign({}, field.input), checked: field.input.checked, onChange: field.input.onChange, classes: {
                root: css.checkbox,
                checked: css.checkbox_checked
            } }), label: React.createElement(React.Fragment, null,
            firstName,
            " ",
            lastName,
            ", ",
            birthdate,
            (!subsidyInfo || subsidyInfo.rejectMessage) && (React.createElement("p", { className: css.noFound }, (subsidyInfo === null || subsidyInfo === void 0 ? void 0 : subsidyInfo.rejectMessage) || t('Not found subsidy for this passenger')))), classes: {
            disabled: css.disabled,
            label: css.label
        }, className: css.traveller }));
};
export default Traveller;
